import React from 'react';
import { GameType } from '../../../types/GameType.ts';
import WeaverStatsModal from './WeaverStatsModal.tsx';
import SubtextStatsModal from './SubtextStatsModal.tsx';
import { GameStatsModalProps } from './types.ts';

const GameStatsModal: React.FC<GameStatsModalProps> = (props) => {
  const { gameType, ...commonProps } = props;
  
  switch (gameType) {
    case GameType.WEAVER:
    case GameType.WEAVER_X:
      return <WeaverStatsModal {...commonProps} gameType={gameType} />;
    case GameType.SUBTEXT:
      return <SubtextStatsModal {...commonProps} gameType={gameType} />;
    default:
      // This should never happen with proper typing, but good to have a fallback
      return null;
  }
};

export default GameStatsModal; 